import { useState } from 'react'
import TextareaBox from '../../../../common/interactive/TextareaBox'
import InputBox from '../../../../common/interactive/InputBox'
import classes from './CreateRequest.module.css'
import Button from '../../../../common/Button'
import { createProcodocsRequest } from '../../../../../lib/fetchApi'
import { notificationActions } from '../../../../../store/notifications'
import { useDispatch, useSelector } from 'react-redux'
import { isManagingAttorney } from '../../../../../lib/primaryItemScripts'

export default function CreateRequest({closeModal, closeModalAndOpenList}) {
    const dispatch = useDispatch()
    const userToken = useSelector(state => state.user.token)
    const caseId = useSelector(state => state.case.activeCase.case.id)
    const selectedProcoDocsAttorney = useSelector(state => state.attorney.selectedProcoDocsAttorney)
    const activeCase = useSelector(state => state.case.activeCase)
    // const [request, setRequest] = useState({
    //     title: '',
    //     description: '',
    // })
    const [isLoading, setIsLoading] = useState(false)
    const submitHandler = async(event) => {
        event.preventDefault()
        setIsLoading(true)
        try {
            const fd = new FormData(event.target)
            const data = Object.fromEntries(fd.entries())

            let body = {
                title: data.title,
                // description: data.description,
                case_attorney_id: selectedProcoDocsAttorney ? selectedProcoDocsAttorney : isManagingAttorney(activeCase)?.id
            }
            const request = await createProcodocsRequest(userToken, caseId, body)
            if (request?.errorMessage) {
                dispatch(notificationActions.setError(request))
            } else {
                if (closeModalAndOpenList) {
                    closeModalAndOpenList()
                }
                // if (closeModal) {
                //     closeModal()
                // }
            }
        } finally {
            setIsLoading(false)
        }
    }
    return <div className={classes.container}>
        
        <form onSubmit={submitHandler} className={classes.form}>
            {/* <div className="row">
                <h3 className={classes.title}>Create Request</h3>
            </div> */}
            {/* <div className="row">
                <InputBox label="Title" type="text" name="title" required={true} placeholder="" />
            </div> */}
            <div className="row">
                <TextareaBox name="title" required={true} placeholder="" />
            </div>
            <div className="row">
                <Button title="Create" btnStyle="btn_small" type={'submit'} isLoading={isLoading}>Create Note</Button>
            </div>
        </form>
    </div>
}